import React from "react";
import { ProgressBar } from "react-bootstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ProgressProfile = ({ title, percentage }) => {
  return (
    <div style={{ width: 100, height: 80 }} className="m-auto">
      <CircularProgressbar
        value={percentage}
        text={`${percentage === -1 ? "N/A" : percentage + "%"}`}
        strokeWidth={10}
        styles={buildStyles({
          pathColor: "#369AFF",
          textColor: "#000",
          textSize: 24,
        })}
      />
      {title && (
        <span className="text-muted font-weight-bold font-size-xs">
          {title}
        </span>
      )}
    </div>
  );
};

const ProgressBarProfile = ({ total_percentage, title }) => {
  return (
    <div className="w-100">
      <div className="d-flex justify-content-between">
        <span className="font-weight-bold text-dark-75">{title ? title : "Profile Completion"}</span>
        <span className="font-weight-bolder text-dark">{total_percentage}%</span>
      </div>
      <div className="w-100">
        <ProgressBar variant="success" now={total_percentage} />
      </div>
    </div>
  );
};

export { ProgressBarProfile };
export default ProgressProfile;
